import { MerchantDto } from '../../dto/merchant.dto';

export interface PosSelectedMerchantMessageDialogResult {
  selectedMerchant?: MerchantDto;
}
